import React from "react";
import { Card } from "../../components/ui/card";
import Header from "../../components/Header";

/**
 * Reusable layout for legal/static pages (Privacy, Terms, etc.).
 * Renders a list of sections from a structured content object so each page
 * only has to declare its strings — no repetitive JSX or ternaries.
 */
const LegalPageLayout = ({ content }) => {
  return (
    <>
      <Header />
      <main className="max-w-4xl mx-auto px-4 py-8">
        <Card className="bg-white rounded-2xl p-8">
          <h1 className="text-3xl font-bold text-slate-900 mb-6">{content.title}</h1>
          <div className="prose prose-slate max-w-none space-y-6">
            {content.lastUpdated && (
              <p className="text-slate-600">{content.lastUpdated}</p>
            )}
            {content.intro && (
              <p className="text-slate-700 font-medium">{content.intro}</p>
            )}
            {content.sections.map((s, idx) => (
              <section key={s.title}>
                <h2 className="text-xl font-semibold text-slate-800 mb-3">
                  {idx + 1}. {s.title}
                </h2>
                {s.intro && <p className="text-slate-600">{s.intro}</p>}
                {s.text && <p className="text-slate-600">{s.text}</p>}
                {s.items && (
                  <ul className="list-disc pl-6 space-y-2 text-slate-600">
                    {s.items.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                )}
                {s.outro && <p className="text-slate-600 mt-3">{s.outro}</p>}
              </section>
            ))}
            {content.outro && (
              <p className="text-slate-600 italic">{content.outro}</p>
            )}
          </div>
        </Card>
      </main>
    </>
  );
};

export default LegalPageLayout;
